import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

/* Stato licenza:
   - enforce ON + non valida  -> OVERLAY a tutto schermo (blocco)
   - valida ma in scadenza (<=30gg) -> banner giallo
   - non valida ma enforce OFF (sviluppo) -> banner rosso informativo
   - altrimenti niente */
export default function LicenseBanner() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => axios.get(`${API}/license/status`).then(r => setSt(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  if (!st) return null;

  const copyMid = () => {
    try { navigator.clipboard.writeText(st.machine_id); toast.success('ID macchina copiato'); } catch {}
  };
  const ricontrolla = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/license/checkin-now`);
      const status = r.data?.status;
      if (status?.valid) { window.location.reload(); return; }
      if (status) setSt(status);
      else load();
    } catch { load(); }
    setBusy(false);
  };

  // 1) Blocco a tutto schermo (enforcement attivo e licenza non valida)
  if (st.enforce && !st.valid) {
    return createPortal(
      <div className="lic-overlay">
        <div className="lic-box">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <h2>Licenza non valida</h2>
          <p className="lic-reason">{st.reason || 'non valida'}</p>
          <p className="lic-msg">Contatta il fornitore per attivare o rinnovare la licenza.</p>
          <div className="lic-mid">ID macchina: <code>{st.machine_id}</code>
            <button className="btn btn-secondary" onClick={copyMid}>Copia</button>
          </div>
          <button className="btn btn-primary" onClick={ricontrolla} disabled={busy} style={{ marginTop: 14, minWidth: 180 }}>
            {busy ? 'Verifica…' : 'Verifica di nuovo'}
          </button>
        </div>
      </div>,
      document.body
    );
  }

  // 2) Banner non bloccanti
  const expiringSoon = st.valid && st.giorni_rimasti != null && st.giorni_rimasti <= 30;
  const invalidPresent = !st.valid && st.reason !== 'nessuna licenza';
  if (expiringSoon) {
    return (
      <div className="lic-banner warn">
        Licenza in scadenza tra <b>{st.giorni_rimasti}</b> giorni
        {st.cliente ? ` · ${st.cliente}` : ''}{st.scadenza ? ` · scad. ${st.scadenza}` : ''}
      </div>
    );
  }
  if (invalidPresent) {
    return (
      <div className="lic-banner err">
        Licenza non valida: <b>{st.reason}</b> — contatta il fornitore.&nbsp;
        <span>ID macchina: <code>{st.machine_id}</code></span>
      </div>
    );
  }
  return null;
}
